var sa = sa || {};
sa.scrollPos = 0;

sa.updateScroll = () => {
	var lastScroll = sa.scrollPos;
	sa.scrollPos = window.scrollY;
	if (lastScroll != sa.scrollPos) {
		if (sa.scrollPos == 0) 
			document.body.classList.remove('has-scrolled');
		else
			document.body.classList.add('has-scrolled'); 
	}
}


	// const root = document.createElement("div")
	// root.innerHTML = `<p>Hello Webpack v11.</p>`
	// document.body.appendChild(root);

	// newOne();newOne();newOne();

	// newOne2();newOne2();newOne2();


document.addEventListener("DOMContentLoaded", function(event) { 

	var elSpamtool = document.getElementById('nl-analyser'),
		elSearch = document.getElementById('frmsearch');

	elSearch.querySelector('label').addEventListener('click', function(){
		elSearch.classList.add('ready');
		elSearch.classList.toggle("active");
	});

	if (elSpamtool) elSpamtool.querySelector('textarea').addEventListener('click', function(){
		elSpamtool.classList.add("active");
		this.focus();
	});

	// window.addEventListener('scroll', sa.updateScroll)
  
});